import MediaCard from "../MediaCard"
import { CardActionArea } from "@mui/material"
import { useEffect, useState, useRef } from "react"

import "./SliderComponent.css"

const colors = ["#0088FE", "#00C49F", "#FFBB28"]
const titles = ["¿Que es?", "Contacta", "Conócenos"]
const urls = [
	"https://images.unsplash.com/photo-1560975219-0392df8cab57?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1039&q=80",
	"https://images.unsplash.com/photo-1596524430615-b46475ddff6e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
	"https://images.unsplash.com/photo-1561652514-742489cce237?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=735&q=80",
]
const descriptions = [
	"¿Quieres saber que es el Hockey Subacuático?",
	"¿Quieres probar el Hockey Subacuático? ¿Quieres entrenar con nosotros? Ponte en contacto con nosotros y te diremos como!",
	"Quieres conocer donde entrenamos, quienes somos? Adelante!",
]
const contentUrls = ["./info", "./contacta", "./info"]
const delay = 5000

function Slideshow() {
	const [index, setIndex] = useState(0)
	const timeoutRef = useRef(null)

	function resetTimeout() {
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current)
		}
	}

	useEffect(() => {
		resetTimeout()
		timeoutRef.current = setTimeout(
			() =>
				setIndex((prevIndex) =>
					prevIndex === colors.length - 1 ? 0 : prevIndex + 1
				),
			delay
		)

		return () => {
			resetTimeout()
		}
	}, [index])

	return (
		<div className="slideshow">
			<div
				className="slideshowSlider"
				style={{ transform: `translate3d(${-index * 100}%, 0, 0)` }}
			>
				{titles.map((title, index) => (
					<div className="slide" key={index}>
						<CardActionArea href={contentUrls[index]}>
							<MediaCard
								key={index}
								image={urls[index]}
								name={title}
								description={descriptions[index]}
							></MediaCard>
						</CardActionArea>
					</div>
				))}
			</div>

			<div className="slideshowDots">
				{colors.map((_, idx) => (
					<div
						key={idx}
						className={`slideshowDot${index === idx ? " active" : ""}`}
						onClick={() => {
							setIndex(idx)
						}}
					></div>
				))}
			</div>
		</div>
	)
}

export default Slideshow
